export default "__VITE_ASSET__MhXK6Sb7__"